import { readdir as re, access as ne, mkdir as x, rm as S, symlink as ie, readFile as C, cp as W, mkdtemp as b, writeFile as L, stat as V } from "node:fs/promises";
import { join as l, resolve as v, dirname as se, basename as q, isAbsolute as oe } from "node:path";
import { pathToFileURL as ae } from "node:url";
import { existsSync as z, mkdirSync as ce, writeFileSync as ue, watch as le } from "node:fs";
import { tmpdir as $ } from "node:os";
import { execFile as de, spawn as F } from "node:child_process";
import { promisify as ge } from "node:util";
function O(e, t) {
  const r = e[t];
  if (typeof r != "string")
    throw new Error(`Plugin package "${t}" must be a string.`);
  return r;
}
function fe(e, t = {}) {
  if (!e || typeof e != "object" || Array.isArray(e))
    throw new Error("Plugin package manifest must be an object.");
  const r = e, n = O(r, "name"), i = O(r, "version"), s = D(
    r.exports,
    "./server"
  ) ?? D(r.exports, "."), a = D(r.exports, "./web"), o = we(
    r.exports,
    "./web",
    t.packageDirectory
  );
  if (!s)
    throw new Error('Plugin package "exports" must define a server entry.');
  return {
    id: n,
    name: n,
    packageName: n,
    serverEntry: s,
    version: i,
    ...a === void 0 ? {} : { webEntry: a },
    ...o === void 0 ? {} : { webStyle: o }
  };
}
async function pe(e) {
  const t = await re(e, { withFileTypes: !0 }).catch(
    () => []
  ), r = [];
  for (const n of t)
    !n.isDirectory() || n.name === "node_modules" || r.push(l(e, n.name, "package.json"));
  return me(r);
}
async function me(e) {
  const t = [];
  for (const r of e)
    try {
      await ne(r), t.push(r);
    } catch {
    }
  return t;
}
function D(e, t) {
  if (typeof e == "string")
    return t === "." ? e : void 0;
  if (!e || typeof e != "object" || Array.isArray(e))
    return;
  const r = e, n = t === "." && !Object.keys(r).some((i) => i.startsWith(".")) ? r : r[t];
  return H(n);
}
function we(e, t, r) {
  if (!e || typeof e != "object" || Array.isArray(e))
    return;
  const i = e[t];
  if (!i || typeof i != "object" || Array.isArray(i))
    return;
  const a = i.style;
  if (typeof a == "string" && !(r && !z(v(r, a))))
    return a;
}
function H(e) {
  if (typeof e == "string")
    return e;
  if (!e || typeof e != "object" || Array.isArray(e))
    return;
  const t = e, r = ["import", "default", "module"];
  for (const n of r) {
    const i = H(t[n]);
    if (i)
      return i;
  }
}
async function K(e) {
  const t = l(e.pluginRoot, "node_modules");
  await x(e.pluginRoot, { recursive: !0 }), await S(t, { force: !0, recursive: !0 }), await ie(e.hostNodeModules, t, "junction");
}
const it = K;
async function st(e) {
  await K({
    hostNodeModules: e.hostNodeModules,
    pluginRoot: e.pluginRoot
  });
  const t = await pe(e.pluginRoot), r = new Set(e.disabledPluginIds ?? []), n = [], i = [];
  for (const s of t) {
    const a = se(s), o = fe(
      JSON.parse(await C(s, "utf8")),
      { packageDirectory: a }
    );
    if (r.has(o.id))
      continue;
    const p = v(a, o.serverEntry), f = await import((e.toImportUrl ?? ye)(
      p,
      e.importVersion ?? o.version
    ));
    if (!f.default)
      throw new Error(
        `Plugin "${o.id}" does not export a default plugin.`
      );
    const m = f.default;
    if (n.push({
      ...m,
      packageName: o.packageName
    }), o.webEntry) {
      const u = q(a);
      i.push({
        id: o.id,
        name: o.name,
        packageName: o.packageName,
        version: o.version,
        webEntry: U(u, o.webEntry),
        ...o.webStyle === void 0 ? {} : { webStyle: U(u, o.webStyle) }
      });
    }
  }
  return { plugins: n, webPlugins: i };
}
function U(e, t) {
  return `/plugin-assets/${encodeURIComponent(e)}/${ve(
    t
  )}`;
}
function ve(e) {
  return e.replace(/^\.\//, "").replace(/^dist\//, "");
}
function ye(e, t) {
  const r = ae(e);
  return t !== void 0 && r.searchParams.set("holdReinPluginVersion", String(t)), r.href;
}
function he(e) {
  const t = e.trim(), r = /^https:\/\/github\.com\/(?<owner>[^/\s]+)\/(?<repo>[^/\s]+?)(?:\.git)?\/?$/u.exec(
    t
  ) ?? /^git@github\.com:(?<owner>[^/\s]+)\/(?<repo>[^/\s]+?)(?:\.git)?$/u.exec(
    t
  );
  if (r != null && r.groups) {
    const { owner: u, repo: g } = r.groups;
    return !u || !g ? void 0 : {
      repositoryUrl: J(
        u,
        g,
        t.startsWith("git@github.com:")
      )
    };
  }
  const n = /^https:\/\/github\.com\/(?<owner>[^/\s]+)\/(?<repo>[^/\s]+)\/(?<kind>tree|blob)\/(?<ref>[^/\s]+)(?:\/(?<path>.*))?\/?$/u.exec(
    t
  );
  if (!(n != null && n.groups))
    return;
  const { kind: i, owner: s, path: a, ref: o, repo: p } = n.groups;
  if (!i || !s || !o || !p)
    return;
  const f = be(a), m = i === "blob" && f.at(-1) === "package.json" ? f.slice(0, -1).join("/") : f.join("/");
  return {
    ref: o,
    repositoryUrl: J(s, p),
    ...m.length === 0 ? {} : { subdirectory: m }
  };
}
function be(e) {
  if (!e)
    return [];
  const t = e.split("/").filter((r) => r.length > 0);
  return t.some((r) => r === "." || r === "..") ? [] : t;
}
function J(e, t, r = !1) {
  return r ? `git@github.com:${e}/${t}.git` : `https://github.com/${e}/${t}.git`;
}
const Pe = ge(de);
async function w(e, t, r, n, i) {
  i == null || i(`Running: ${ke(t, r)}
`);
  const s = e ? await e(t, r, n) : await Pe(t, [...r], { cwd: n });
  s != null && s.stdout && (i == null || i(_(s.stdout))), s != null && s.stderr && (i == null || i(_(s.stderr)));
}
function ke(e, t) {
  return [e, ...t].join(" ");
}
function _(e) {
  return e.endsWith(`
`) ? e : `${e}
`;
}
async function y(e) {
  const t = JSON.parse(
    await C(l(e, "package.json"), "utf8")
  );
  if (!t || typeof t != "object" || Array.isArray(t))
    throw new Error("Plugin package manifest must be an object.");
  const r = t, n = r.name;
  if (typeof n != "string" || n.length === 0)
    throw new Error('Plugin package "name" must be a string.');
  if (!Se(r.exports))
    throw new Error('Plugin package "exports" must define "./server".');
  return {
    exports: r.exports,
    name: n,
    packageJson: r,
    publishConfig: r.publishConfig
  };
}
function Ee(e) {
  return e.publishConfig && typeof e.publishConfig == "object" && !Array.isArray(e.publishConfig) ? {
    ...T(e.packageJson),
    ...e.publishConfig,
    name: e.name
  } : T(e.packageJson);
}
function xe(e) {
  const t = P(
    e.exports["./server"]
  );
  return !!(t && !je(t));
}
function Se(e) {
  return !e || typeof e != "object" || Array.isArray(e) ? !1 : Object.hasOwn(e, "./server");
}
function T(e) {
  const t = { ...e };
  return delete t.publishConfig, t;
}
function je(e) {
  return e.startsWith("./src/") || e.includes("/src/") || e.endsWith(".ts") || e.endsWith(".tsx");
}
function P(e) {
  if (typeof e == "string")
    return e;
  if (!e || typeof e != "object" || Array.isArray(e))
    return;
  const t = e;
  return P(t.import) ?? P(t.default) ?? P(t.module);
}
function Re(e) {
  return e.replaceAll("/", "__");
}
async function E(e) {
  var r;
  const t = l(
    e.pluginRoot,
    Re(e.packageName)
  );
  return await x(e.pluginRoot, { recursive: !0 }), await S(t, { force: !0, recursive: !0 }), (r = e.write) == null || r.call(
    e,
    `Copying plugin files: ${e.sourcePackageDir} -> ${t}
`
  ), await W(e.sourcePackageDir, t, { recursive: !0 }), t;
}
async function Ne(e) {
  const t = e.tempRoot ?? await b(l($(), "hold-rein-plugin-"));
  await x(t, { recursive: !0 });
  const r = await b(l(t, "install-"));
  await L(
    l(r, "package.json"),
    JSON.stringify({ private: !0, type: "module" }, null, 2)
  ), await w(
    e.runCommand,
    "npm",
    ["install", e.packageName, "--ignore-scripts"],
    r,
    e.write
  );
  const n = l(
    r,
    "node_modules",
    ...e.packageName.split("/")
  );
  return await y(n), E({
    packageName: e.packageName,
    pluginRoot: e.pluginRoot,
    sourcePackageDir: n,
    write: e.write
  });
}
async function ot(e) {
  const t = he(e.source);
  if (t)
    return Ce(e, t);
  const r = await Y(
    e.source,
    e.currentWorkingDirectory
  );
  return r ? De(e, r) : Ne({
    packageName: e.source,
    pluginRoot: e.pluginRoot,
    ...e.runCommand === void 0 ? {} : { runCommand: e.runCommand },
    ...e.tempRoot === void 0 ? {} : { tempRoot: e.tempRoot },
    ...e.write === void 0 ? {} : { write: e.write }
  });
}
async function De(e, t) {
  return await y(t), await X(e.runCommand, t, e.write), await w(
    e.runCommand,
    "pnpm",
    ["install"],
    t,
    e.write
  ), await w(
    e.runCommand,
    "pnpm",
    ["build"],
    t,
    e.write
  ), Q(t, e.pluginRoot, e.write);
}
async function Ce(e, t) {
  const r = e.tempRoot ?? await b(l($(), "hold-rein-plugin-"));
  await x(r, { recursive: !0 });
  const n = await b(l(r, "github-")), i = e.installGitRepository ?? Ae;
  try {
    t.ref ? await i(
      t.repositoryUrl,
      n,
      t.ref
    ) : await i(t.repositoryUrl, n);
    const s = t.subdirectory === void 0 ? n : l(n, t.subdirectory), a = await y(s);
    return xe(a) ? await E({
      packageName: a.name,
      pluginRoot: e.pluginRoot,
      sourcePackageDir: s,
      write: e.write
    }) : (await X(e.runCommand, s, e.write), await w(
      e.runCommand,
      "pnpm",
      ["install"],
      s,
      e.write
    ), await w(
      e.runCommand,
      "pnpm",
      ["build"],
      s,
      e.write
    ), await Q(
      s,
      e.pluginRoot,
      e.write
    ));
  } finally {
    await S(n, { force: !0, recursive: !0 });
  }
}
async function Q(e, t, r) {
  const n = await Y(
    l(e, "dist")
  );
  if (n && await $e(n)) {
    const a = await y(n);
    return E({
      packageName: a.name,
      pluginRoot: t,
      sourcePackageDir: n,
      write: r
    });
  }
  const i = await y(e), s = await b(l($(), "hold-rein-plugin-package-"));
  try {
    return await L(
      l(s, "package.json"),
      `${JSON.stringify(Ee(i), null, 2)}
`
    ), await W(l(e, "dist"), l(s, "dist"), {
      recursive: !0
    }), await y(s), await E({
      packageName: i.name,
      pluginRoot: t,
      sourcePackageDir: s,
      write: r
    });
  } finally {
    await S(s, { force: !0, recursive: !0 });
  }
}
async function $e(e) {
  try {
    return await V(l(e, "package.json")), !0;
  } catch {
    return !1;
  }
}
async function X(e, t, r) {
  try {
    await w(e, "pnpm", ["--version"], t, r);
  } catch {
    try {
      await w(
        e,
        "npm",
        ["install", "--global", "pnpm"],
        t,
        r
      );
    } catch {
      throw new Error("pnpm is required to build plugin sources");
    }
  }
}
async function Y(e, t = process.cwd()) {
  const r = oe(e) ? e : v(t, e);
  try {
    return (await V(r)).isDirectory() ? r : void 0;
  } catch {
    return;
  }
}
async function Ae(e, t) {
  await w(
    void 0,
    "git",
    ["clone", "--depth", "1", e, t],
    process.cwd()
  );
}
const Me = "0.0.7", B = {
  version: Me
}, Ie = "0.0.2", G = {
  version: Ie
}, Oe = {
  name: "@hold-rein/plugins-base",
  version: "0.0.0",
  private: !1,
  type: "module",
  main: "./src/server.ts",
  module: "./src/server.ts",
  types: "./src/server.ts",
  exports: {
    "./server": {
      types: "./src/server.ts",
      import: "./src/server.ts",
      require: "./src/server.ts"
    },
    "./web": {
      types: "./src/web.ts",
      style: "./dist/style.css",
      import: "./src/web.ts",
      require: "./src/web.ts"
    }
  },
  files: ["dist"],
  publishConfig: {
    access: "public",
    main: "./dist/server.cjs",
    module: "./dist/server.js",
    types: "./dist/server.d.ts",
    exports: {
      "./server": {
        types: "./dist/server.d.ts",
        import: "./dist/server.js",
        require: "./dist/server.cjs"
      },
      "./web": {
        types: "./dist/web.d.ts",
        style: "./dist/style.css",
        default: "./dist/web.umd.cjs",
        require: "./dist/web.umd.cjs"
      }
    }
  },
  scripts: {
    build: "vite build --config vite.config.ts && vite build --config vite.web.config.ts && tsc -p tsconfig.json --emitDeclarationOnly",
    dev: "vite --host 127.0.0.1 --config vite.web.config.ts",
    typecheck: "tsc -p tsconfig.json --noEmit"
  },
  peerDependencies: {
    "@earendil-works/pi-agent-core": "0.75.4",
    "@earendil-works/pi-ai": "0.76.0",
    "@hold-rein/plugin-server": `^${B.version}`,
    express: "5.2.1",
    "better-sqlite3": "12.10.0",
    "cron-parser": "^5.6.1",
    "drizzle-orm": "0.45.2",
    "node-cron": "^4.6.0",
    "@ant-design/icons": "6.2.5",
    "@hold-rein/plugin-web": `^${G.version}`,
    "@monaco-editor/react": "4.7.0",
    antd: "6.4.3",
    "monaco-editor": "0.55.1",
    react: "^19.0.0",
    "react-dom": "^19.0.0"
  },
  devDependencies: {
    "@earendil-works/pi-agent-core": "0.75.4",
    "@earendil-works/pi-ai": "0.76.0",
    "@hold-rein/plugin-server": `^${B.version}`,
    express: "5.2.1",
    vite: "6.3.5",
    "better-sqlite3": "12.10.0",
    "cron-parser": "^5.6.1",
    "drizzle-orm": "0.45.2",
    "node-cron": "^4.6.0",
    "@ant-design/icons": "6.2.5",
    "@hold-rein/plugin-web": `^${G.version}`,
    "@monaco-editor/react": "4.7.0",
    "@types/react": "19.2.15",
    antd: "6.4.3",
    "monaco-editor": "0.55.1",
    react: "19.2.6",
    "react-dom": "19.2.6"
  }
}, Ue = `{
  "compilerOptions": {
    "declaration": true,
    "declarationMap": true,
    "esModuleInterop": true,
    "exactOptionalPropertyTypes": true,
    "forceConsistentCasingInFileNames": true,
    "isolatedModules": true,
    "module": "ESNext",
    "moduleResolution": "Bundler",
    "noFallthroughCasesInSwitch": true,
    "noImplicitOverride": true,
    "noUncheckedIndexedAccess": true,
    "resolveJsonModule": true,
    "skipLibCheck": true,
    "strict": true,
    "target": "ES2022",
    "useDefineForClassFields": true,
    "verbatimModuleSyntax": true,
    "jsx": "react-jsx",
    "lib": ["DOM", "DOM.Iterable", "ES2022"],
    "outDir": "dist",
    "rootDir": "src"
  },
  "include": ["src/**/*.ts", "src/**/*.tsx"],
  "exclude": ["src/**/*.test.ts", "src/**/*.test.tsx"]
}
`, Je = `import { builtinModules } from "node:module";

import { defineConfig } from "vite";

const nodeBuiltins = builtinModules.flatMap((name) => [
  name,
  \`node:\${name}\`
]);

export default defineConfig({
  build: {
    lib: {
      entry: "src/server.ts",
      fileName: (format) => \`server.\${format === "cjs" ? "cjs" : "js"}\`,
      formats: ["es", "cjs"]
    },
    rollupOptions: {
      external: [
        ...nodeBuiltins,
        "@hold-rein/plugin-server",
        "@earendil-works/pi-agent-core",
        "@earendil-works/pi-ai",
        "express",
        "better-sqlite3",
        "cron-parser",
        "drizzle-orm",
        "node-cron"
      ]
    },
    sourcemap: true
  }
});
`, _e = `import { createHoldReinSharedVitePlugin } from "@hold-rein/plugin-web/vite-shared-plugin";
import { defineConfig } from "vite";

export default defineConfig(({ command }) => ({
  plugins: command === "serve" ? [createHoldReinSharedVitePlugin()] : [],
  build: {
    emptyOutDir: false,
    lib: {
      cssFileName: "style",
      entry: "src/web.ts",
      fileName: () => "web.umd.cjs",
      formats: ["umd"],
      name: "HoldReinPlugin"
    },
    sourcemap: true,
    rollupOptions: {
      external: [
        "@ant-design/icons",
        "@hold-rein/plugin-web",
        "@monaco-editor/react",
        "antd",
        "monaco-editor",
        "react",
        "react-dom",
        "react/jsx-runtime"
      ]
    }
  }
}));
`, at = (e, t = {}) => {
  const r = t.path ?? e, n = t.name === void 0 ? r : l(r, t.name), i = q(n), s = `hold-rein-plugin-${i}`, a = {
    ...Oe,
    name: s
  };
  return Te(n, {
    "package.json": `${JSON.stringify(a, null, 2)}
`,
    "tsconfig.json": Ue,
    "vite.config.ts": Je,
    "vite.web.config.ts": _e,
    "src/plugin-id.ts": `export const PLUGIN_ID = "__${i}__plugin";
`,
    "src/server.ts": Be(),
    "src/web.ts": Ge()
  }), { packageName: s };
};
function Te(e, t) {
  for (const r of Object.keys(t)) {
    const n = l(e, r);
    if (z(n))
      throw new Error(`Refusing to overwrite existing file: ${r}`);
  }
  ce(l(e, "src"), { recursive: !0 });
  for (const [r, n] of Object.entries(t))
    ue(l(e, r), n);
}
function Be() {
  return `import type { ServerPlugin } from "@hold-rein/plugin-server";

import { PLUGIN_ID } from "./plugin-id";

const serverPlugin: ServerPlugin.Plugin = {
  id: PLUGIN_ID
};

export default serverPlugin;
`;
}
function Ge() {
  return `import type { WebPlugin } from "@hold-rein/plugin-web";

import { PLUGIN_ID } from "./plugin-id";

const webPlugin: WebPlugin.Plugin = {
  id: PLUGIN_ID
};

export default webPlugin;
`;
}
const We = 100;
async function ct(e) {
  var f, m;
  const t = e.spawn ?? Fe, r = e.watch ?? Ke, n = e.buildServerBundle ?? He, i = e.debounceMs ?? We;
  let s;
  const a = /* @__PURE__ */ new Set(), o = [], p = (u) => {
    e.onReload && (a.add(u), s !== void 0 && clearTimeout(s), s = setTimeout(async () => {
      var c;
      s = void 0;
      const g = [...a];
      a.clear(), await Promise.all(
        g.map(
          (d) => n(d.packageDirectory)
        )
      ), await ((c = e.onReload) == null ? void 0 : c.call(e));
    }, i));
  };
  for (const u of e.pluginPaths) {
    const g = v(u), c = await Le(g);
    if (!((f = c.scripts) != null && f.dev))
      throw new Error(
        `Development plugin "${c.name}" must define a dev script.`
      );
    const d = v(
      g,
      Ve(c.publishConfig, "./server")
    ), h = Z(c.exports, "./web");
    await n(g);
    const j = {
      dev: !0,
      id: c.name,
      name: c.name,
      packageName: c.name,
      version: c.version,
      webEntry: "",
      webEntryType: "module"
    }, A = t("pnpm", ["dev"], { cwd: g }), R = {
      child: A,
      manifest: j,
      packageDirectory: g,
      serverEntryPath: d,
      webEntryPath: h
    }, ee = r(
      v(g, "src"),
      () => p(R)
    );
    o.push({ ...R, watcher: ee }), (m = A.stdout) == null || m.on("data", (te) => {
      var M;
      const N = qe(String(te));
      if (N !== void 0) {
        R.devServerOrigin = N;
        const I = new URL(ze(h), N).href;
        j.webEntry !== I && (j.webEntry = I, (M = e.onReload) == null || M.call(e));
      }
    });
  }
  return {
    async close() {
      var u;
      s !== void 0 && clearTimeout(s);
      for (const g of o)
        (u = g.watcher) == null || u.close(), g.child.kill();
    },
    getServerPluginEntries() {
      return o.map((u) => ({
        entryPath: u.serverEntryPath,
        manifest: u.manifest,
        packageDirectory: u.packageDirectory
      }));
    },
    getWebPluginManifests() {
      return o.filter((u) => u.manifest.webEntry.length > 0).map((u) => u.manifest);
    }
  };
}
async function Le(e) {
  const t = JSON.parse(
    await C(v(e, "package.json"), "utf8")
  );
  if (typeof t.name != "string")
    throw new Error('Development plugin package "name" must be a string.');
  if (typeof t.version != "string")
    throw new Error('Development plugin package "version" must be a string.');
  return {
    name: t.name,
    ...t.exports === void 0 ? {} : { exports: t.exports },
    ...t.publishConfig === void 0 ? {} : { publishConfig: t.publishConfig },
    ...t.scripts === void 0 ? {} : { scripts: t.scripts },
    version: t.version
  };
}
function Ve(e, t) {
  if (!e || typeof e != "object" || Array.isArray(e))
    throw new Error(
      `Development plugin publishConfig must define "${t}".`
    );
  return Z(
    e.exports,
    t
  );
}
function Z(e, t) {
  const r = k(
    typeof e == "object" && e !== null ? e[t] : void 0
  );
  if (r === void 0)
    throw new Error(`Development plugin exports must define "${t}".`);
  return r;
}
function k(e) {
  if (typeof e == "string")
    return e;
  if (!e || typeof e != "object" || Array.isArray(e))
    return;
  const t = e;
  return k(t.import) ?? k(t.default) ?? k(t.module);
}
function qe(e) {
  const t = e.match(/https?:\/\/(?:localhost|127\.0\.0\.1):\d+\//);
  if (t)
    return t[0];
}
function ze(e) {
  return e.replace(/^\.\//, "");
}
const Fe = (e, t, r) => F(e, [...t], {
  cwd: r.cwd,
  stdio: ["ignore", "pipe", "inherit"]
}), He = (e) => new Promise((t, r) => {
  const n = F(
    "pnpm",
    ["exec", "vite", "build", "--config", "vite.config.ts"],
    {
      cwd: e,
      stdio: "inherit"
    }
  );
  n.once("error", r), n.once("exit", (i) => {
    if (i === 0) {
      t();
      return;
    }
    r(new Error(`Server plugin build failed with exit code ${i}.`));
  });
}), Ke = (e, t) => le(e, { recursive: !0 }, t);
async function Qe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ut() {
  const e = /* @__PURE__ */ new Map();
  return {
    register(t) {
      if (e.has(t.id))
        throw new Error(`Server plugin "${t.id}" is already registered.`);
      e.set(t.id, t);
    },
    replaceAll(t) {
      e.clear();
      for (const r of t) {
        if (e.has(r.id))
          throw new Error(`Server plugin "${r.id}" is already registered.`);
        e.set(r.id, r);
      }
    },
    list() {
      return [...e.values()];
    },
    get(t) {
      return e.get(t);
    },
    has(t) {
      return e.has(t);
    },
    async registerRoutes(t, r) {
      for (const n of e.values()) {
        if (!n.registerRoutes) continue;
        const i = await n.registerRoutes(r);
        t.use(`/${n.id}`, i);
      }
    },
    async resolveContributions(t, r = {}) {
      const n = r.activePluginPackageNames === void 0 ? void 0 : new Set(r.activePluginPackageNames), i = [], s = [], a = [], o = [], p = [], f = [], m = [...e.values()].filter(
        (c) => n === void 0 || n.has(c.packageName ?? c.id)
      ), u = r.pluginFilter ? await r.pluginFilter(m) : m;
      for (const c of u) {
        if (!c.contributionResolver)
          continue;
        const d = await Qe(
          c.contributionResolver,
          t
        );
        i.push(...d.tools ?? []), s.push(...d.skills ?? []), a.push(...d.skillDirs ?? []), o.push(...d.systemPrompts ?? []), d.subscribe && p.push(d.subscribe), d.onAgentEnd && f.push({
          handler: d.onAgentEnd,
          priority: d.agentEndPriority ?? 0
        });
      }
      return f.sort((c, d) => d.priority - c.priority), {
        ...{
          tools: i,
          skills: s,
          skillDirs: a,
          systemPrompts: o
        },
        ...p.length > 0 ? {
          subscribe(c) {
            for (const d of p)
              d(c);
          }
        } : {},
        ...f.length > 0 ? {
          async onAgentEnd(c) {
            for (const { handler: d } of f) {
              const h = await d(c);
              if (h)
                return h;
            }
          }
        } : {}
      };
    }
  };
}
export {
  E as copyInstalledPluginPackage,
  ut as createServerPluginRegistry,
  pe as discoverServerPluginManifests,
  Re as encodePluginDirectoryName,
  at as initPluginPackage,
  Ne as installNpmPluginPackage,
  ot as installPluginPackage,
  K as linkServerPluginNodeModules,
  it as linkServerPluginSharedPackages,
  st as loadInstalledServerPlugins,
  fe as parseServerPluginManifest,
  ct as startDevPluginManager
};
//# sourceMappingURL=index.js.map
